import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../../utils/axios';

export enum LanguagesJSON {
  UI = 'ui',
  NOTIFICATION = 'notification',
  EMAIL = 'email',
  LANDING = 'landing',
}

const downloadLanguagesCsv = async (type: LanguagesJSON) => {
  const response = await axiosInstance.get(`/s3/languages-csv/${type}`, {
    responseType: 'blob',
  });

  let filename = `${type}_translations.csv`;
  const disposition = response.headers['content-disposition'];
  if (disposition) {
    const match = disposition.match(/filename="?(.+?)"?$/);
    if (match && match[1]) filename = match[1];
  }

  return { blob: response.data, filename };
};

const useLanguagesCsvExport = () => {
  return useMutation({
    mutationFn: downloadLanguagesCsv,
    onSuccess: ({ blob, filename }) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    },
    onError: (err) => {
      alert('Failed to export languages CSV');
      console.error(err);
    },
  });
};

export default useLanguagesCsvExport;
